import {UtilConstant} from '../redux_constants/utils.constant';

export const setUIBusy = (message) => ({
    type: UtilConstant.SET_UI_BUSY,
    busyMessage: message === undefined ? "..." : message,
})

export const setUIIdle = () => ({
    type: UtilConstant.SET_UI_IDLE,
})